module.exports = __webpack_public_path__ + "img/ads.d5274c5a.gif";